<!--
 * @Author: 罗川平 2150673512@qq.com
 * @Date: 2023-02-22 15:53:23
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2025-06-04 16:19:13
 * @FilePath: \pigbox\src\views\Shop\Shop.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div style="width:100%;height:100%;">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>商家审核</span>
        <div>
          <span style="margin-right:15px">状态选择:</span>
          <el-select v-model="chooseType" placeholder="请选择" @change="choosetTypeChange">
            <el-option v-for="item in typeChooseList" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>
      </div>
      <el-table :data="tableData" style="width: 100%" height="500px">
        <el-table-column prop="merchantName" label="商品名" width="180"></el-table-column>
        <!-- <el-table-column prop="merchantName" label="姓名" width="180"></el-table-column> -->
        <el-table-column prop="name" label="店主名"></el-table-column>
        <el-table-column prop="merchantNum" label="店主电话"></el-table-column>
        <el-table-column label="店铺图片">
          <template slot-scope="scope">
            <el-image style="width: 50px; height: 50px" :src="scope.row.merchantPic"></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="licenseExamine" label="状态">
          <template slot-scope="scope">
            <el-tag type="success" v-show="scope.row.licenseExamine==1">已通过</el-tag>
            <el-tag type="info" v-show="scope.row.licenseExamine==0">待审核</el-tag>
            <el-tag type="warning" v-show="scope.row.licenseExamine==2">未通过</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="licenseExamine" label="操作">
          <template slot-scope="scope">
            <div class="tableBtnBox">
              <el-button
                type="primary"
                v-if="scope.row.licenseExamine==0"
                size="mini"
                @click="showInfo(scope.row)"
              >开始审核</el-button>
              <el-button
                type="info"
                v-if="scope.row.licenseExamine==2"
                size="mini"
                @click="showInfo(scope.row)"
              >查看信息</el-button>
              <el-button
                type="info"
                v-if="scope.row.licenseExamine==1"
                size="mini"
                @click="showInfo(scope.row)"
              >查看信息</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
      <el-form ref="form" :model="infoData" label-width="100px">
        <el-form-item label="姓名">
          <el-input v-model="infoData.name" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="身份证号">
          <el-input v-model="infoData.cardNumber" :disabled="true"></el-input>
        </el-form-item>

        <el-form-item label="营业执照号">
          <el-input v-model="infoData.licenseNumber" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="执照有效期">
          <el-input v-model="infoData.validDate" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="营业执照图片">
          <div>
            <el-image
              style="width: 50px; height: 50px"
              :src="infoData.licensePic"
              :preview-src-list="srcList"
            ></el-image>
          </div>
        </el-form-item>
        <el-form-item label="店铺名">
          <el-input v-model="infoData.merchantName" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="店铺图片">
          <div>
            <el-image
              style="width: 50px; height: 50px"
              :src="infoData.merchantPic"
              :preview-src-list="srcList"
            ></el-image>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer" v-show="chooseShopType==0">
        <el-button @click="Reject">拒绝申请</el-button>
        <el-button type="primary" @click="Pass">通过申请</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [],
      chooseShopType: "",
      savedTableData: [],
      dialogVisible: false,
      infoData: {},
      srcList: [],
      chooseType: "",
      typeChooseList: [
        {
          value: -1,
          label: "全部"
        },
        {
          value: 0,
          label: "待审核"
        },
        {
          value: 1,
          label: "已通过"
        },
        {
          value: 2,
          label: "未通过"
        }
      ]
    };
  },
  created() {
    this.getData();
  },
  methods: {
    choosetTypeChange(e) {
      // console.log(e);
      if (e == -1) {
        this.tableData = [...this.savedTableData];
      } else {
        let data = [...this.savedTableData];

        let arr4 = data.filter(item => item.licenseExamine == e);
        console.log(arr4);
        this.tableData = arr4;
      }
    },
    Reject() {
      this.$axios({
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        url: `ExamineService/auditFailedMerchant/${this.infoData.id}` // 接口地址
      }).then(res => {
        console.log(res);
        // this.infoData = res;
        this.getData();
        this.dialogVisible = false;
        // this.srcList = [res.licensePic, res.merchantPic];
        // this.tableData = res;
        // if (res.id != null) {
        //   this.$store.commit("setUserId", res);
        //   this.$router.push("/shop");
        // }
      });
    },
    Pass() {
      this.$axios({
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        url: `ExamineService/auditSuccessMerchant/${this.infoData.id}` // 接口地址
      }).then(res => {
        console.log(res);
        // this.infoData = res;
        this.getData();
        this.dialogVisible = false;

        // this.srcList = [res.licensePic, res.merchantPic];
        // this.tableData = res;
        // if (res.id != null) {
        //   this.$store.commit("setUserId", res);
        //   this.$router.push("/shop");
        // }
      });
    },
    showInfo(data) {
      this.chooseShopType = data.licenseExamine;
      this.$axios({
        method: "get",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        url: `ExamineService/queryAllMerchantById/${data.id}` // 接口地址
      }).then(res => {
        console.log(res);
        this.infoData = res;
        this.dialogVisible = true;
        this.srcList = [res.licensePic, res.merchantPic];
        // this.tableData = res;
        // if (res.id != null) {
        //   this.$store.commit("setUserId", res);
        //   this.$router.push("/shop");
        // }
      });
    },
    getData() {
      this.$axios({
        method: "get",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        url: "ExamineService/queryAllMerchant" // 接口地址
      }).then(res => {
        console.log(res);
        this.tableData = res;
        this.savedTableData = res;
        // if (res.id != null) {
        //   this.$store.commit("setUserId", res);
        //   this.$router.push("/shop");
        // }
      });
    }
  }
};
</script>

<style>
</style>